(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "../../Api", "./log", "../../../utils/jwt"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("../../Api"), require("./log"), require("../../../utils/jwt"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.regenerator, a.asyncToGenerator, a.Api, a.log, a.jwt), a.auth = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f) {
  "use strict"; // => auth/create-token/

  function g() {
    return h.apply(this, arguments);
  }

  function h() {
    return h = (0, c.default)(
    /*#__PURE__*/
    b.default.mark(function a(c) {
      return b.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return (0, e.default)("create auth token start"), a.abrupt("return", d.default.request(r, {
                method: d.POST,
                body: c
              }));

            case 2:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), h.apply(this, arguments);
  }

  function i() {
    return j.apply(this, arguments);
  }

  function j() {
    return j = (0, c.default)(
    /*#__PURE__*/
    b.default.mark(function a(c, f) {
      var g, h;
      return b.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return (0, e.default)("auth request start"), a.next = 3, d.default.request(p, {
                method: d.POST,
                body: {
                  email: c,
                  password: f
                }
              });

            case 3:
              return g = a.sent, h = g.token, global.localStorage.setItem(o, h), a.abrupt("return", h);

            case 7:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), j.apply(this, arguments);
  } // Legacy


  function k() {
    return l.apply(this, arguments);
  }

  function l() {
    return l = (0, c.default)(
    /*#__PURE__*/
    b.default.mark(function a() {
      var c, e, f;
      return b.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              if (c = t(), c) {
                a.next = 3;
                break;
              }

              return a.abrupt("return", null);

            case 3:
              return a.next = 5, d.default.request(q, {
                method: d.POST,
                body: {
                  token: c
                }
              });

            case 5:
              return e = a.sent, f = e.token, global.localStorage.setItem(o, f), a.abrupt("return", f);

            case 9:
            case "end":
              return a.stop();
          }
        }
      }, a);
    })), l.apply(this, arguments);
  }

  var m = require("@babel/runtime/helpers/interopRequireWildcard"),
      n = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.createToken = g, a.obtainToken = i, a.refreshToken = k, a.default = a.invalidToken = a.getToken = a.clearToken = void 0, b = n(b), c = n(c), d = m(d), e = n(e);

  var o = "tf:auth:token",
      p = "auth/obtain-token/",
      q = "auth/refresh-token/",
      r = "accounts/register/",
      s = function s() {
    return global.localStorage.removeItem(o);
  };

  a.clearToken = s;

  var t = function t() {
    var a = global.localStorage.getItem(o);
    return (0, f.checkTokenValidity)(a) ? a : void // Drop token if invalid
    s();
  };

  a.getToken = t;
  a.invalidToken = s, d.default.on(d.EVENT_FAILURE, function (a) {
    401 === a.status && s();
  });
  a.default = {
    clearToken: s,
    createToken: g,
    getToken: t,
    obtainToken: i,
    refreshToken: k
  };
});